export interface NotificationItem {
  Id: number | string;
  ProcessingStatusDescription?: string;
  CreatedDate: string;
  MaterialNumber?: string;
  MaterialDescription?: string;
  Description?: string;
}

export interface ApiResponse {
  Data: NotificationItem[];
  TotalItems: number;
}

export interface StatusOption {
  Id: number;
  Description: string;
}

export interface NotificationsToolbarProps {
  processingStatuses: number[];
  minCreatedDate: string;
  maxCreatedDate: string;
  hasActiveFilters: boolean;
  onStatusChange: (value: number[]) => void;
  onDateChange: (prop: string, value: string) => void;
  onApplyFilters: () => void;
  onExportToCsv?: () => void;
  onClearFilters?: () => void;
}

export interface NotificationsTableProps {
  items: NotificationItem[];
}

export const PAGE_SIZE = 10;
